import { useEffect, useRef } from "react";
import { getMessageComponent } from "./messageTypes";
import { getValidMessages } from "./chatUtils";
import {
  getDateDividerLabel,
  getMessageDayKey,
} from "./utils/messageDateUtils";
import DateDivider from "./components/DateDivider";

export default function MessageList({ messages = [], backgroundStyle }) {
  const messagesContainerRef = useRef(null);

  const validMessages = getValidMessages(messages);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [validMessages]);

  const renderMessage = (message) => {
    const messageType = message.content?.type;
    
    if (!messageType) {
      return null;
    }

    const MessageComponent = getMessageComponent(messageType);
    
    if (!MessageComponent) {
      console.warn(`Unsupported message type: ${messageType}`);
      return null;
    }

    return <MessageComponent key={message.messageId} message={message} />;
  };

  const renderMessagesWithDividers = () => {
    let previousDayKey = null;

    return validMessages.flatMap((message) => {
      const currentDayKey = getMessageDayKey(message.createdAt);
      const shouldShowDivider = currentDayKey && currentDayKey !== previousDayKey;
      previousDayKey = currentDayKey;

      const items = [];

      if (shouldShowDivider) {
        items.push(
          <DateDivider
            key={`date-${currentDayKey}`}
            label={getDateDividerLabel(message.createdAt)}
          />
        );
      }

      items.push(renderMessage(message));
      return items;
    });
  };

  return (
    <div
      ref={messagesContainerRef}
      className="flex-1 p-4 bg-[#efeae2] dark:bg-slate-950 overflow-y-auto"
      style={backgroundStyle}
    >
      <div className="space-y-3 max-w-3xl xl:max-w-4xl 2xl:max-w-5xl mx-auto pb-4">
        {validMessages.length === 0 ? (
          <div className="text-center text-gray-500 dark:text-slate-400 py-8">
            No messages yet
          </div>
        ) : (
          renderMessagesWithDividers()
        )}
      </div>
    </div>
  );
}
